import React, { useRef } from 'react'
import styles from './helper-modal.scss'
import ReactModal from 'react-modal'
import Audio from '../../lib/audio'

const HelperModal = ({ onClose, coverItem, videoUrl, title }) => {
  const videoRef = useRef()
  const coverRef = useRef()
  const handleVideoClick = () => {
    if (!videoRef) return
    if (videoRef.current.paused) {
      if (videoRef.current.innerHTML.trim() == '') {
        videoRef.current.innerHTML = `<source src='${videoUrl}' type='video/mp4'/>`
      }
      coverRef.current.hidden = true
      Audio.stop()
      videoRef.current.play()
    } else {
      coverRef.current.hidden = false
      videoRef.current.pause()
    }
  }
  return (
    <ReactModal
      overlayClassName={styles.ReactModal__Overlay}
      className={styles.ReactModal__Content}
      isOpen={true}
      title={window.L('teach.user.helper')}
      closeTimeoutMS={400}
    >
      <div className={styles.modalContainer}>
        <div className={styles.header}>
          <div className={styles.titleBlock}></div>
          <div className={styles.titleBlock}>
            <span>{title}</span>
          </div>
          <div className={styles.titleBlock} onClick={onClose}>
            <p>×</p>
            <p>关闭</p>
          </div>
        </div>
        <div className={styles.videoArea}>
          <div
            className={styles.videoCover}
            ref={coverRef}
            onClick={handleVideoClick}
          ></div>
          <video
            ref={videoRef}
            poster={coverItem.rawURL}
            webkit-playsinline='true'
            style={{ width: '100%' }}
            onClick={handleVideoClick}
          >
          </video>
        </div>
      </div>
    </ReactModal>
  )
}

export default HelperModal
